import React, { useEffect, useState } from 'react';
import { Box, Typography, Tabs, Tab, Button } from '@mui/material';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import ModelPortfolios from '../components/ModelPortfolios';
import ActivePortfolios from '../components/ActivePortfolios';

// Sub-paths that belong to Model Portfolios (tab 0)
const MODEL_SUBS = new Set(['rankings', 'league', 'rotation', 'models', 'signals', 'earnings', 'movers', 'radar', 'news', 'prices', 'performance']);

const Portfolio = () => {
  const { sub } = useParams<{ sub?: string }>();
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const [mainTab, setMainTab] = useState(sub === 'active' ? 1 : 0);
  // Follow the URL, e.g. an active portfolio opening its model page (/portfolio/models?id=…).
  useEffect(() => { setMainTab(sub === 'active' ? 1 : 0); }, [sub]);

  const handleTabChange = (_: React.SyntheticEvent, v: number) => {
    setMainTab(v);
    navigate(v === 1 ? '/portfolio/active' : '/portfolio', { replace: true });
  };

  // Derive which ModelPortfolios sub-tab to open from the URL
  const modelSub = (sub && MODEL_SUBS.has(sub)) ? sub : undefined;
  const modelId = Number(params.get('id')) || undefined;
  const tab = params.get('tab') || undefined;

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Portfolio
        </Typography>
        <Tabs value={mainTab} onChange={handleTabChange}>
          <Tab label="Model Portfolios" />
          <Tab label="Active Portfolios" />
        </Tabs>
      </Box>

      {mainTab === 0 && <ModelPortfolios initialSub={modelSub} initialModelId={modelId} initialTab={tab} />}
      {mainTab === 1 && (modelId ? (
        <>
          <Button size="small" onClick={() => navigate('/portfolio/active')} sx={{ textTransform: 'none', mb: 1, px: 0.5 }}>
            ← All active portfolios
          </Button>
          <ModelPortfolios activeOnly initialModelId={modelId} initialTab={tab} />
        </>
      ) : <ActivePortfolios />)}
    </Box>
  );
};

export default Portfolio;
